import API from './apiCreate'
import { getParams } from './getParams'

export type HistoryCategory = 'schedule' | 'journal' | 'ktp' | 'students' | 'employees'
export type HistoryAction = 'create' | 'copy' | 'reschedule' | 'swap' | 'update' | 'delete'
export interface HistoryLesson {
  id: number
  subject: string
  lesson_type: string
  recurrence: string
  date: string
  start_time: string
  end_time: string
  teacher: string
  groups: string
  students: string
}
export interface ScheduleHistoryPresentation {
  action: HistoryAction
  action_label: string
  scope: string
  before: HistoryLesson[]
  after: HistoryLesson[]
  changes: { label: string; old: string; new: string }[]
}
export interface ChangeHistoryRow {
  id: number
  entity_id: number
  entity_type: string
  entity_label: string
  subject_id?: number
  actor_id?: number
  actor_name: string
  action: HistoryAction
  source: string
  created_at: number
  changes: Record<string, { old: unknown; new: unknown }>
  presentation?: ScheduleHistoryPresentation
}

export const changeHistoryApi = {
  index: (params: Record<string, unknown>) =>
    API.get(`change-history/index${getParams(params)}`),
  user: (id: number) => API.get(`change-history/user?id=${id}`),
}
